module.exports = "html,\nbody,\n.view {\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n\n.raleway {\n  font-family: 'Raleway', sans-serif; }\n\n@media (max-width: 768px) {\n  .full-bg-img,\n  .view {\n    height: auto;\n    position: relative; } }\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./node_modules/sass-loader/lib/loader.js??ref--8-3!./src/styles.scss
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./node_modules/sass-loader/lib/loader.js??ref--8-3!./src/styles.scss
// module chunks = styles